import { useMemo } from "react";
/**
 * Return a stable string whose identity only flips when the per-item keys
 * change. Handy for feeding into downstream `useMemo` / `useQuery` keys
 * when the input list's array identity is unstable (fresh copy every render)
 * but its content is conceptually unchanged.
 *
 * The separator defaults to `|`; pick a character that cannot appear in a
 * key so the fingerprint stays unambiguous.
 *
 * **Stability:** `keyFn` is included in the memo deps, so pass a stable
 * reference (module-level function or `useCallback`). An inline function
 * defeats the memo and the fingerprint recomputes every render — still
 * correct, just wasted work.
 *
 * @example
 * const fp = useIdentityFingerprint(openAssignments, assignmentKey);
 * useEffect(() => { ... }, [fp]);
 */ export function useIdentityFingerprint(items, keyFn, separator = "|") {
    return useMemo(()=>{
        if (!items || items.length === 0) return "";
        return items.map(keyFn).join(separator);
    }, [
        items,
        keyFn,
        separator
    ]);
}

//# sourceMappingURL=useIdentityFingerprint.js.map